import { render } from "./MyInfoPage.vue?vue&type=template&id=3512a00c&scoped=true"
import script from "./MyInfoPage.vue?vue&type=script&lang=js"
export * from "./MyInfoPage.vue?vue&type=script&lang=js"

import "./MyInfoPage.vue?vue&type=style&index=0&id=3512a00c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3512a00c"]])

export default __exports__